import React from 'react';
import { ImageListItem } from '../../ImageListItem';
import { useDraggableListItem } from '../../../../../_lib/DragAndDrop';
import { EditableGalleryItem, EditableGalleryItemProps } from './EditableGalleryItem';
import { ImageListItemModifier } from '../../ImageListItem';

export function DraggableImageListItem(props: EditableGalleryItemProps) {
  const { getListItemProps, isDragging } = useDraggableListItem(props, EditableGalleryItem);

  return (
    <ImageListItem {...getListItemProps()} modifier={isDragging ? ImageListItemModifier.DRAGGING : undefined}>
      <EditableGalleryItem {...props} />
    </ImageListItem>
  );
}
